const Wire = ({wire}) => {

    return (
        <img src={`${process.env.PUBLIC_URL}images/cableColor/${wire}-wire.png`} className="defaultWire-img" alt=""/>
    )

}
export default Wire;